import { cloneDeep } from "lodash";
export class AgentStateProxy {
    constructor(wrapper) {
        this.cache = new Map();
        this.wrapper = wrapper;
        return new Proxy(this, {
            set(target, property, value) {
                target.cache.set(property, value);
                return true;
            },
            get(target, property) {
                if (property in target) {
                    if (typeof target[property] === "function") {
                        return target[property].bind(target);
                    }
                    else {
                        return target[property];
                    }
                }
                else {
                    const cached = target.cache.get(property);
                    if (cached !== undefined) {
                        return cached;
                    }
                    const value = target.wrapper.get(property);
                    target.cache.set(property, value);
                    return value;
                }
            },
        });
    }
    get(key) {
        if (arguments.length !== 1) {
            throw new Error("state.get only takes a key argument");
        }
        const cached = this.cache.get(key);
        if (cached !== undefined) {
            return cloneDeep(cached);
        }
        const value = this.wrapper.get(key);
        this.cache.set(key, value);
        return cloneDeep(value);
    }
    set(key, value) {
        if (arguments.length !== 2) {
            throw new Error("state.set only takes two arguments - key, and value");
        }
        const cloned = cloneDeep(value);
        this.cache.set(key, cloned);
        return true;
    }
    modify(key, fn) {
        this.set(key, fn(this.get(key)));
    }
    addMessage(to, type, data) {
        const messages = this.cache.get("messages");
        if (messages === undefined) {
            this.wrapper.add_message(to, type, data);
        }
        else {
            const message = {
                to: [to],
                type,
                data,
            };
            messages.push(message);
        }
    }
    behaviorIndex() {
        return this.wrapper.behavior_index();
    }
}
//# sourceMappingURL=AgentStateProxy.js.map